// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4c7d9dc2","976":"9d77da74"}[chunkId] + ".chunk.js";
};